(function($){

function set_video_height() {
	
	const
	body = $('body');

	if (body.hasClass('home')) {
		const
		header = $('.site-header'),
		video_wrapper = $('.background-video');
		
		let
		header_height = header[0].clientHeight,
		new_header_height = header_height + set_admin_offset(),
		header_height_rem = new_header_height / 16;

		function get_admin_bar_height() {
			let admin_bar_height = ( $(window).width() > 783 ) ? 32 : 46;
			return admin_bar_height;
		}

		function set_admin_offset() {
			let admin_bar_offset = (body.hasClass('logged-in') && body.hasClass('admin-bar')) ? get_admin_bar_height() : 0;
			return admin_bar_offset;
		}
		
		let video_height = ( $(window).width() > 783 ) ? 66.5 : 100;
		
	}
}

set_video_height();
$(window).resize( set_video_height );
$('.videobgframe').attr('title', 'bg-video-hero');

})(jQuery);